import React, { useEffect, useState, useRef, useContext } from 'react';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, PrintDocument, formatDateMMDDYYYY } from "../../GlobalScript";
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import Cookies from 'js-cookie';
import PaginationBar from '../../PaginationBar';
import Calendar from 'react-calendar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import HistoryDetail from '../HistoryDetail';
import FooterDealer from '../../FooterDealer.js';
import { ShoppingCartContext } from '../ShoppingCartContext';
import "react-calendar/dist/Calendar.css";

export default function CreditHistory() {

    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [currentPage, setCurrentPage] = useState(() => {
        const saved = localStorage.getItem("creditSearch");
        if (!saved) return 0;

        const parsed = JSON.parse(saved);
        return parsed.pagenum ? parsed.pagenum - 1 : 0;
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [restoredSearch, setRestoredSearch] = useState(null);
    const [orderItems, setOrderItems] = useState([]);
    const [firstLoad, setFirstLoad] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');

    const formatDate = (date) => {
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);
    const MIN_YEAR = 2000;
    const MAX_DATE = new Date();
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [dateFromInput, setDateFromInput] = useState('');
    const [dateToInput, setDateToInput] = useState('');
    const normalize = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const [showFromCal, setShowFromCal] = useState(false);
    const [showToCal, setShowToCal] = useState(false);

    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    //const [itemOffset, setItemOffset] = useState(0);
    //const endOffset = itemOffset + pageResults;
    //const currentItems = orderItems.slice(itemOffset, endOffset);
    const currentItems = orderItems;
    const pageCount = Math.ceil(resultsLength / pageResults);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [StatusList, setStatusList] = useState(null);
    const [pop, setPop] = useState(false);
    const historyType = 'credit';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [exchange, setExchange] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [isConfirmationLink, setIsConfirmationLink] = useState(false);
    const [searchType, setSearchType] = useState(1);
    const [invalidSearch, setInvalidSearch] = useState(false);
    const [UserInfo, setUserInfo] = useState(null);
    const [requestCallTags, setRequestCallTags] = useState(new Map());
    const [initialLoad, setInitialLoad] = useState(true);
    const [lastUpdatedDate, setLastUpdatedDate] = useState(null);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        document.title = 'K-Dealer - Credit Request History';
    }, []);
 
    const handleDetailsModalShow = async (order) => {
        //setSelectedOrder(order);
        handlePop();
        await GetRequestDetail(order);
        setShowDetailsModal(true);
        setExchange(order.exchange);
    }

    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
    }

    useEffect(() => {
        if (showDetailsModal === true) {
            handleClosePop();
        }
    }, [showDetailsModal])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            localStorage.removeItem("creditSearch");
            setIsConfirmationLink(true);
            setKeyword(location.state.id);
            setDateFrom('');
            setDateTo('');
            setDateFromInput('');
            setDateToInput('');
            setStatus('');
            setSearchType(2);
            GetListItems(1, '', false);
        } else if (initialLoad === true) {
            handleSearchClick();
            setInitialLoad(false);
        }
    }, [location, initialLoad])

    useEffect(() => {
        CheckSession();
        if (!UserInfo) {
            let ck = GetCoockie();
            setUserInfo(ck);
            window.GlobalLoading++;
        }
        if (window.GlobalLoading === 1) {
            window.location.reload();
        }
    }, [UserInfo])
    useEffect(() => {
        if (isConfirmationLink) {
            if (location.state && location.state.id && location.state.id !== '') {
                LoadtatusList('', false);
            }
        }
    }, [keyword])

    useEffect(() => {
        if (isConfirmationLink) {
            if (location.state && location.state.id && location.state.id !== '' && orderItems && orderItems.length > 0) {
                handleDetailsModalShow(orderItems[0])
            }
        }
    }, [orderItems])
   
    const GetRequestDetail = async (order) => {
        const response = await fetch("kdealer/GetCreditRequestDetail/" + order.orderID);
        if (response.status !== 200) {
            return;
        }
        const res = await response.json();

        const orderToShow = {
            order: order,
            orderDetail: res
        }
        setSelectedOrder(orderToShow);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'status') {
            setStatus(value);
        } else if (name === 'dateFrom' || name === 'dateTo') {
            const ref = name === 'dateFrom' ? dateFromRef : dateToRef;
            const inputEl = ref.current;
            const start = inputEl.selectionStart;
            const end = inputEl.selectionEnd;

            const masked = formatMaskedDate(value);

            if (name === 'dateFrom') {
                setDateFromInput(masked);
            } else {
                setDateToInput(masked);
            }

            const parsed = parseMaskedDate(masked);
            if (parsed) {
                if (name === 'dateFrom') setDateFrom(parsed);
                else setDateTo(parsed);
            } else {
                if (name === 'dateFrom') {
                    setDateFrom(null);
                } else {
                    setDateTo(null);
                }
            }

            requestAnimationFrame(() => {
                const newPos = calculateNewCaretPosition(value, masked, start);
                inputEl.setSelectionRange(newPos, newPos);
            });
        } else if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const ResetSearch = async () => {
        setKeyword('');
        setStatus('');
        setDateFrom('');
        setDateTo('');
        setDateFromInput('');
        setDateToInput('');
        setPageResults(25);
        setCurrentPage(0);
        setErrorMessage('');
        localStorage.removeItem("creditSearch");
        setFirstLoad(true);
    }

    const dateFromRef = useRef(null);
    const dateToRef = useRef(null);

    const calculateNewCaretPosition = (oldValue, newValue, oldPos) => {
        if (newValue.length < oldValue.length) {
            return Math.max(oldPos - 1, 0);
        }

        if (newValue[oldPos] === "/") {
            return oldPos + 1;
        }

        return oldPos;
    }

    const handleFromChange = (newFrom) => {
        setDateFrom(newFrom);
        setDateFromInput(formatDate(newFrom));
        setShowFromCal(false);
    }

    const handleToChange = (newTo) => {
        setDateTo(newTo);
        setDateToInput(formatDate(newTo));
        setShowToCal(false);
    }

    const formatMaskedDate = (value) => {
        const digits = value.replace(/\D/g, "").slice(0, 8);

        let mm = digits.slice(0, 2);
        let dd = digits.slice(2, 4);
        let yyyy = digits.slice(4, 8);

        let formatted = mm;
        if (dd) formatted += "/" + dd;
        if (yyyy) formatted += "/" + yyyy;

        return formatted;
    }

    const parseMaskedDate = (str) => {
        const [mm, dd, yyyy] = str.split("/");
        if (mm?.length === 2 && dd?.length === 2 && yyyy?.length === 4) {
            if (!isValidDate(yyyy, mm, dd)) {
                setErrorMessage('Please enter a valid date');
                setInvalidSearch(true);
                return null;
            }

            if (Number(yyyy) < MIN_YEAR) {
                setErrorMessage(`Year must be ${MIN_YEAR} or later`);
                setInvalidSearch(true);
                return null;
            }

            const parsedDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));

            if (parsedDate > MAX_DATE) {
                setErrorMessage('Date cannot be in the future');
                setInvalidSearch(true);
                return null;
            }

            /*const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));*/
            setInvalidSearch(false);
            setErrorMessage('');
            return parsedDate;
        }
        return null;
    }

    const isValidDate = (year, month, day) => {
        const d = new Date(year, month - 1, day);

        return (
            d.getFullYear() === Number(year) &&
            d.getMonth() === Number(month) - 1 &&
            d.getDate() === Number(day)
        );
    }

    useEffect(() => {
        if (isConfirmationLink) return;
        const saved = localStorage.getItem("creditSearch");

        if (saved) {
            const parsed = JSON.parse(saved);
            setKeyword(parsed.keyword || "");
            setStatus(parsed.status || "");
            setDateFrom(parsed.dateFrom || "");
            setDateTo(parsed.dateTo || "");
            setDateFromInput(parsed.dateFromInput || "");
            setDateToInput(parsed.dateToInput || "");
            setPageResults(parsed.count || 25);
            setCurrentPage((parsed.pagenum || 1) - 1);

            setRestoredSearch(parsed);
        }
    }, [isConfirmationLink])

    useEffect(() => {
        if (!restoredSearch) return;
        if (isConfirmationLink) return;

        //Do not automatically search, just save search criteria

        //GetListItems(restoredSearch.pagenum, "", false, {
        //    keyword: restoredSearch.keyword,
        //    status: restoredSearch.status,
        //    dateFrom: restoredSearch.dateFrom,
        //    dateTo: restoredSearch.dateTo,
        //    pageResults: restoredSearch.count
        //});
    }, [restoredSearch, isConfirmationLink])

    useEffect(() => {
        if (!StatusList) {
            LoadtatusList();
        }
    }, [StatusList]);

    const LoadtatusList = async () => {
        try {
            CheckSession();
            const response = await fetch("kdealer/GetCRStatusList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setStatusList(lst);

        } catch (e) {
            console.log(e);
            return;
        }
    }

    const handleSearchClick = async () => {
        try {
            setShowToCal(false);
            setShowFromCal(false);

            if (!isConfirmationLink) {
                //if (!dateFrom) {
                //    setErrorMessage('Please enter a Date From value.')
                //    return;
                //}

                //if (!dateTo) {
                //    setErrorMessage('Please enter a Date To value.')
                //    return;
                //}

                const from = normalize(new Date(dateFrom));
                const to = normalize(new Date(dateTo));
                const diffInDays = (to - from) / (24 * 60 * 60 * 1000);

                //if (diffInDays > 90) {
                //    setErrorMessage("Please enter a date range no bigger than 90 days.");
                //    return;
                //}

                GetListItems(1, '', false);
            } else {
                GetListItems(1, '', false);
                setIsConfirmationLink(false);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleButtonClick = (orderNumber) => {
        setActiveRow(prevRow => (prevRow === orderNumber ? null : orderNumber));
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('button')) {
            setActiveRow(null);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handlePageClick = (input) => {
        const pageIndex = typeof input === "number" ? input : input.selected;
        setCurrentPage(pageIndex);
        GetListItems(pageIndex + 1, '', false);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            const newSize = Number(tempPage) || 1; // basic safety 
            setPageResults(newSize);
            setCurrentPage(0);
        }
    };

    useEffect(() => {
        if (!restoredSearch) return;
        if (!firstLoad) {
            GetListItems(1, '', false);
        }
    }, [pageResults])

    const GetListItems = async (pagenum, orderby, inc, overrides = {}) => {
        if (invalidSearch) return;

        const { keyword: kw = keyword, status: st = status, dateFrom: df = dateFrom, dateTo: dt = dateTo, pageResults: pr = pageResults, } = overrides;

        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const data = {
                keyword: kw,
                status: st,
                dateFrom: df ? formatDateMMDDYYYY(new Date(df)) : '',
                dateTo: dt ? formatDateMMDDYYYY(new Date(dt)) : '',
                orderBy: orderby,
                inc: false,
                dealerId: user.dealerID,
                pageNum: pagenum,
                count: pr,
                searchType: searchType
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetCreditRequestHistory", requestOptions);
            if (response.status !== 200) {
                handleClosePop();
                return;
            } else {
                debugger;
                const rec = await response.json();
                setOrderItems(rec);
                setErrorMessage('');
                setResultsLength(rec[0]?.totalOrders ?? 0);
                handleClosePop();
                localStorage.setItem(
                    "creditSearch",
                    JSON.stringify({
                        keyword,
                        status,
                        dateFrom,
                        dateTo,
                        dateFromInput,
                        dateToInput,
                        pagenum,
                        count: pageResults
                    })
                );
                setFirstLoad(false);
            }
            setSearchType(1);
            const dataDate = {
                label: user.dealerID,
                value: '2'
            }
            const requestOptionsDate = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(dataDate)
            };
            const responseDate = await fetch("kdealer/GetLastCallAPIDate", requestOptionsDate);
            if (responseDate.status === 200) {
                setLastUpdatedDate(await responseDate.text());
            }
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }
    //end

    const handlePrint = (crNum) => {
        if (crNum) {
            PrintDocument(crNum);
        }
    }

    const handleCallTag = (crNum) => {
        window.open(`https://www.k-dealer.com/site/crcreditrequest/CRCallTagRequest.asp?CrReqstNbr=${crNum}`, "_blank", "noopener,noreferrer");
    }

    const loadOptions = async (orderID) => {
        if (requestCallTags.has(orderID)) {
            return;
        }
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: orderID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/CheckIfShowRequestCallTags", requestOptions);
            if (response.status !== 200) {
                // setErrorMsg('There was an error while attempting to get the details of your order. Please try again later.')
                // handleErrorModalShow();
                return;
            }
            const res = await response.text();
            if (res === "1") {
                setRequestCallTags(prev => {
                    const updated = new Map(prev);
                    updated.set(orderID, true);
                    return updated;
                });
            } else {
                setRequestCallTags(prev => {
                    const updated = new Map(prev);
                    updated.set(orderID, false);
                    return updated;
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const handleRefreshOrders = async () => {
        const user = GetCoockie();
        if (!user) return;

        try {
            handlePop();
            const data = {
                dealerID: user.dealerID,
                userKey: user.userKey,
                from: 2
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/SynchCreditRequest", requestOptions);
            if (response.status !== 200) {
                //error message
                setErrorMessage('There was an error while attempting to update orders. Please try again later.');
                handleClosePop();
            } else {
                GetListItems(1, '', false);
            }
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">CREDIT REQUEST HISTORY</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        {/*<Row className="excel-row">*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Credit Request</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Credit Request Items</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row className="gy-3">
                                    <Col lg={3} md={6}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <FloatingLabel label="Order Status" className="mb-4">
                                            <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">
                                                <option value={''}>All</option>
                                                {
                                                    StatusList && StatusList.map((item, index) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <Row className="g-2">
                                            <Col sm={9}>
                                                <FloatingLabel label="Date From" className="mb-4">
                                                    <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFromInput} className={'form-control'} onChange={handleChange} name="dateFrom" ref={dateFromRef} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <div onClick={() => setShowFromCal((prev) => !prev)} className="calendar-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                        <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                    </svg>
                                                </div>
                                            </Col>
                                        </Row>
                                        {showFromCal &&
                                            <Row>
                                                <Col sm={12}>
                                                    <Calendar value={dateFrom} onChange={handleFromChange} minDate={new Date(2000, 0, 1)} maxDate={new Date()} />
                                                </Col>
                                            </Row>
                                        }
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <Row className="g-2">
                                            <Col sm={9}>
                                                <FloatingLabel label="Date To" className="mb-4">
                                                    <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateToInput} className={'form-control'} onChange={handleChange} name="dateTo" ref={dateToRef} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <div onClick={() => setShowToCal((prev) => !prev)} className="calendar-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                        <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                    </svg>
                                                </div>
                                            </Col>
                                        </Row>
                                        {showToCal &&
                                            <Row>
                                                <Col sm={12}>
                                                    <Calendar value={dateTo} onChange={handleToChange} minDate={new Date(2000, 0, 1)} maxDate={new Date()} />
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                </Row>

                                <Row className="gy-3">
                                    <Col sm={6}>
                                        <div className="default-row mt-2">
                                            <p>Last Updated: {lastUpdatedDate ? lastUpdatedDate : ''}</p>

                                            <p className="clickable underline green-text ml-4" onClick={handleRefreshOrders}>Refresh</p>
                                        </div>
                                    </Col>

                                    <Col lg={{ offset: 2 }} md={{ offset: 1 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch}>Reset Search</p>
                                    </Col>

                                    <Col className="text-right mb-3">
                                        <Button variant="secondary" onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>

                                {errorMessage &&
                                    <Row>
                                        <Col sm={12} className="text-center">
                                            <p className="red">{errorMessage}</p>
                                        </Col>
                                    </Row>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5 mb-4">
                    <Col sm={12}>

                        {!firstLoad ?
                            <Card className="">
                                <Card.Body>
                                    <Row className="table-legend text-center">
                                        <Col sm={12}>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Submitted</span>
                                                <span className="svg-holder"><img src="../../../Images/Completed.svg" alt="" className="" /> Completed</span>
                                                <span className="svg-holder"><img src="../../../Images/AllocatedExchange.svg" alt="" className="" /> Allocated Exchange</span>
                                                <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <PaginationBar
                                        resultsLength={resultsLength}
                                        pageCount={pageCount}
                                        currentPage={currentPage}
                                        pageResults={pageResults}
                                        tempPage={tempPage}
                                        onTempPageChange={handleChange}
                                        onPageResultsChange={changePageResults}
                                        onPageChange={handlePageClick}
                                    />

                                    <Row>
                                        <Col sm={12} className={currentItems.length > 2 ? "order-table" : "order-table no-scroll-lg"}>
                                            <Table hover responsive className="compact-table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>CREDIT <br /> REQUEST #</th>
                                                        <th>REQUEST <br /> DATE</th>
                                                        <th>REQUESTED <br /> BY</th>
                                                        <th>STATUS</th>
                                                        <th>KMC <br /> INVOICE</th>
                                                        <th>TOTAL</th>
                                                        <th>RETURN <br /> DOCS</th>
                                                        <th width="10%"></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>    
                                                    {currentItems && currentItems.map((item, index) => (
                                                        <tr className="" key={index}>
                                                            <td>{(currentPage * pageResults) + index + 1}</td>
                                                            <td>{item.orderID}</td>
                                                            <td>{item.orderDate}</td>
                                                            <td className="text-left">{item.orderBy} <br /> {item.orderByName}</td>
                                                            <td className="table-img"><span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                            <td>{item.invoice}</td>
                                                            <td>${item.total}</td>
                                                            <td className="text-center">
                                                                {item.status === "Submitted" &&
                                                                    <span className="svg-holder small-svg clickable" onClick={() => handlePrint(item.orderID)}>
                                                                        <img src="../../../Images/printer-icon.svg" alt="Print" style={{ height: '40px', marginTop: '-8px' }} />
                                                                    </span>
                                                                }
                                                            </td>
                                                            <td>
                                                                <Button variant="primary" className="btn-maintain" onClick={() => handleDetailsModalShow(item)}>
                                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                    </svg>
                                                                    VIEW
                                                                </Button>
                                                            </td>
                                                            <td ref={dropdownRef} style={{ position: activeRow === item.orderID ? 'absolute' : 'static' }}>
                                                                {item.status === "Submitted" && 
                                                                    <DropdownButton
                                                                        variant="outline-dark"
                                                                        title="Actions"
                                                                        id="input-group-dropdown-1"
                                                                        onClick={() => loadOptions(item.orderID)}
                                                                    >
                                                                        <Dropdown.Item onClick={() => handlePrint(item.orderID)}>Print Return Documents</Dropdown.Item>
                                                                        {requestCallTags.get(item.orderID) &&
                                                                            <Dropdown.Item onClick={() => handleCallTag(item.orderID)}>Request Call Tag</Dropdown.Item>
                                                                        }
                                                                    </DropdownButton>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )) }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                    <PaginationBar
                                        resultsLength={resultsLength}
                                        pageCount={pageCount}
                                        currentPage={currentPage}
                                        pageResults={pageResults}
                                        tempPage={tempPage}
                                        onTempPageChange={handleChange}
                                        onPageResultsChange={changePageResults}
                                        onPageChange={handlePageClick}
                                    />
                                </Card.Body>
                            </Card>
                        :
                            <Card className="">
                                <Card.Body>
                                    <Row>
                                        <Col sm={12} className="text-center">
                                            <p className="bold mt-5 mb-5 svg-carat">
                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                    <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                </svg>
                                                Initiate a search above to view results
                                            </p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        }
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <HistoryDetail show={showDetailsModal} handleClose={handleDetailsModalClose} order={selectedOrder} historyType={historyType} exchange={exchange} />
        </>
    );
}